import React from 'react';
/**
 * Product image + color thumbnails for the Gen2 E-Chest Gear page.
 * Self-contained — not shared with any other product page.
 */
export function Gallery() {
  return <div className="w-full md:w-1/2 flex flex-col items-center" data-id="element-355">
      <div className="bg-white rounded-xl p-4 mb-4 w-full max-w-md flex justify-center" data-id="element-356">
        <img src="https://cdn.magicpatterns.com/uploads/kfguP8tNDqA8zXYkxoyPcg/Gen2_E-Chest_Gear_Adult_Size.jpg" alt="Gen2 E-Chest Gear Adult Size" className="block w-full h-auto object-contain" data-id="element-357" />
      </div>
      <div className="flex gap-4 justify-center" data-id="element-358">
        <div className="w-16 h-16 border border-gray-200 rounded p-1 cursor-pointer hover:border-red-500" data-id="element-359">
          <img src="https://cdn.magicpatterns.com/uploads/kfguP8tNDqA8zXYkxoyPcg/Gen2_E-Chest_Gear_Adult_Size.jpg" alt="Red Thumbnail" className="block w-full h-full object-contain" data-id="element-360" />
        </div>
        <div className="w-16 h-16 border border-gray-200 rounded p-1 cursor-pointer hover:border-blue-500" data-id="element-361">
          <img src="https://cdn.magicpatterns.com/uploads/kfguP8tNDqA8zXYkxoyPcg/Gen2_E-Chest_Gear_Adult_Size.jpg" alt="Blue Thumbnail" className="block w-full h-full object-contain grayscale" style={{
          filter: 'hue-rotate(220deg)'
        }} data-id="element-362" />
        </div>
      </div>
    </div>;
}